<template>
  <div class="alert" v-if="showAlert">
    <el-alert
            class="elalert"
            :title="showTitle"
            type="error">
    </el-alert>
  </div>
</template>
<script>
  import toolkit from "@/util/toolkit"
  export default {
    data(){
      return{
        browser: toolkit.identifyBrowser(),
        isMac: false,
        whiteList: ['谷歌', 'Safari', '360', 'QQ']
      }
    },
    created(){
      this.isMac = toolkit.isMac()
    },
    computed: {
      showAlert(){
        return !this.whiteList.includes(this.browser) && toolkit.isPc()
      },
      showTitle(){
        return `当前浏览器支持不佳，可能影响您的面试效果和体验。建议您使用最新版 Chrome浏览器 进行面试`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .alert{
    padding: 0px 40px;
    .elalert{
      margin: 20px 0;
    }
  }
</style>
<style lang="scss">
  .elalert{
    .el-alert__content{
      .el-alert__title{
        font-size: 18px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BrowserAlert.vue